import { PINLockPlayerPopup } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useCallback, useEffect, useMemo } from 'react'
import { EXTERNAL_PAYMENT_PINLOCK_ID } from '~/features/payment/index.h'
import { profilesFeaturesModel } from '~/features/profiles'
import { $unlocked, resetUnlocked } from '../../profiles'
import { $enterPinDescription, emptyPinLockState } from '../model'
import { usePinLockPlayerBase } from './usePinLockPlayerBase'

export const usePinLockPlayerPaymentPopup = (
  pinLocked?: boolean,
  showPaymentPopup?: boolean | null
) => {
  const {
    pinLockPopup,
    disabled,
    openPinLockPopupEvent,
    autoSubmitPinCodeCallback,
    changePinCodeCallback,
  } = usePinLockPlayerBase()

  const enterPinDescription = useUnit($enterPinDescription)
  const resetUnlockedEvent = useUnit(resetUnlocked)
  const isActiveProfileRegular = useUnit(
    profilesFeaturesModel.$isActiveProfileRegular
  )
  const unlocked = useUnit($unlocked)

  const showPinlockPlayerPaymentPopup = useMemo(() => {
    return !isActiveProfileRegular && !unlocked && showPaymentPopup
  }, [isActiveProfileRegular, unlocked, showPaymentPopup])

  useEffect(() => {
    if (!pinLocked && showPinlockPlayerPaymentPopup) {
      openPinLockPopupEvent({
        ...emptyPinLockState,
        id: EXTERNAL_PAYMENT_PINLOCK_ID,
        locked: true,
        profileUnlock: true,
      })
    }
  }, [pinLocked, openPinLockPopupEvent, showPinlockPlayerPaymentPopup])

  const PINLockPlayerPaymentPopupComponent = useCallback(
    () => (
      <PINLockPlayerPopup
        disabled={disabled}
        title={enterPinDescription}
        invalid={pinLockPopup.invalid}
        errorMessage={pinLockPopup.errorMessage}
        onCompleteInput={autoSubmitPinCodeCallback}
        onChangeInput={changePinCodeCallback}
        valueAfterInvalid={pinLockPopup.valueAfterInvalid}
      />
    ),
    [
      autoSubmitPinCodeCallback,
      changePinCodeCallback,
      enterPinDescription,
      disabled,
      pinLockPopup.errorMessage,
      pinLockPopup.invalid,
      pinLockPopup.valueAfterInvalid,
    ]
  )

  return {
    PINLockPlayerPaymentPopupComponent,
    resetUnlockedProfile: resetUnlockedEvent,
    showPinlockPlayerPaymentPopup,
  }
}
